/* eslint-disable func-style*/
(function() {
  'use strict';
  const contactOpties = document.querySelectorAll('.js-contactoptie'),
        toggleMore = document.querySelectorAll('.js-toggle-more');

  if (contactOpties) {
    let coClicked = function(event, item) {
      let cSiblings = item.parentElement.querySelectorAll('.js-contactoptie');

      event.preventDefault();
      event.stopPropagation();
      if (item.classList.contains('is-active')) {
        item.classList.remove('is-active');
      } else {
        cSiblings.forEach(cItem => {
          cItem.classList.remove('is-active');
        });
        item.classList.add('is-active');
      }
    };

    contactOpties.forEach(item => {
      item.addEventListener('mouseup', event => coClicked(event, item));
      item.addEventListener('keyup', event => {
        if (event.keyCode === 32 || event.keyCode === 13) {
          coClicked(event, item);
        }
      });
    });
  }

  if (toggleMore) {
    let toClicked = function(event, item) {
      event.preventDefault();
      event.stopPropagation();
      item.parentElement.classList.toggle('is-expanded');
    };

    toggleMore.forEach(item => {
      item.addEventListener('mouseup', event => toClicked(event, item));
      item.addEventListener('keyup', event => {
        if (event.keyCode === 32 || event.keyCode === 13) {
          toClicked(event, item);
        }
      });
    });
  }
})();
